import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.989}
    height={20.924}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19142 15412"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:212.127}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528322688576">
        <path
          d="M13816 1928c35 34 70 69 104 103h-29c-540 5-1079 10-1619 15-5-546-10-1091-16-1637v-21c520 513 1040 1027 1560 1540zM12091 190c0 30 1 59 1 89 6 616 11 1233 17 1850 1 43 37 82 82 82l1821-18c35 0 70 0 106-1 27 0 47-11 60-27 4-6 8-13 11-20 15-26 15-59-9-87-3-4-6-8-10-11-565-558-1131-1116-1696-1674-82-80-163-160-244-240-20-20-46-26-71-22-36 7-69 37-68 79z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
          }}
        />
        <path
          d="M14012 2193c1 28 5 58 5 81 1 86 2 173 3 259 2 277 5 553 7 829 8 779 15 1558 23 2338h163c-6-625-12-1249-18-1873-4-528-9-1056-14-1585-1-30-1-55-3-77-13 16-33 27-60 27-36 1-71 1-106 1zM6227 15235v-70H4936v-1074c0 39-31 71-70 71h-70v1073c0 39 31 70 70 70h1430c-38 0-69-31-69-70zM14346 15235v-1073h-70c-39 0-70-32-70-71v1074h-1290v70c0 39-32 70-70 70h1430c39 0 70-31 70-70zM14276 13960h70v-1368c0-151-24-291-63-411-30-89-69-167-116-227-67-87-148-139-235-139H5210c-87 0-168 52-235 139-108 141-179 374-179 638v1368h70c39 0 70 59 70 131v-1499c0-75 9-145 24-209 43-180 139-305 250-305h8722c111 0 207 126 250 305 15 64 24 134 24 209v1499c0-72 31-131 70-131zM1156 7837h1114c59 0 106 48 106 106s-47 106-106 106H1156c-58 0-105-48-105-106s47-106 105-106zm0 352h1114c136 0 246-110 246-246 0-135-110-246-246-246H1156c-135 0-246 111-246 246 0 136 111 246 246 246z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
          }}
        />
        <path
          d="M176 13605h4690c39 0 70-32 70-70 0-39-31-70-70-70H176c-39 0-70 31-70 70 0 38 31 70 70 70zM5083 9459h13853c39 0 71-32 71-70 0-39-32-70-71-70H206c-39 0-70 31-70 70 0 38 31 70 70 70h4877zM4796 15235v-70H246v-1003h-70c-39 0-70-32-70-71v1144c0 39 31 70 70 70h4690c-39 0-70-31-70-70zM18966 14162h-70v1003h-4550v70c0 39-31 70-70 70h4690c39 0 70-31 70-70v-1144c0 39-31 71-70 71zM5042 5074c-11-1075-21-2151-31-3226-3-355-7-709-10-1064-1-109-2-219-3-328 0-35 5-77 5-116 438-4 877-8 1316-13 965-9 1931-18 2896-27 824-8 1648-15 2472-23 107-1 214-2 322-3 10 0 49 4 83 5 0-30-1-59-1-89 0-42 32-72 68-79-2 0-5-2-8-2-40-7-89 1-130 1-680 7-1361 13-2041 19-999 10-1997 19-2996 29-656 6-1313 12-1969 18-34 0-67 1-100 1-44 1-83 37-82 82 4 428 8 857 12 1285 9 1028 19 2057 29 3085 3 357 7 714 10 1071h164c-3-209-4-418-6-626z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
          }}
        />
        <path
          d="M18371 5966H771c-21 0-42 1-63 3-337 32-602 317-602 663v7459c0-38 31-69 70-69h70V9459h-40c-39 0-70-32-70-70 0-39 31-70 70-70h40V6632c0-244 167-449 393-508 42-11 86-17 132-17h17600c290 0 525 235 525 525v2687h40c39 0 71 31 71 70 0 38-32 70-71 70h-40v4563h70c39 0 70 31 70 69V6632c0-29-2-58-6-86-42-326-321-580-659-580z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
          }}
        />
        <path
          d="M12776 14701v327H6367v-427c0-293 122-559 272-709 82-82 172-130 256-130h5352c238 0 529 387 529 839v100zm140 466v-566c0-629-360-1117-669-1117H6895c-36 0-73 8-109 20-156 53-312 216-420 446-85 182-139 405-139 651v566c0 76 31 138 69 138h6550c38 0 70-62 70-138zM14346 13465h-70c-39 0-70 31-70 70 0 38 31 70 70 70h4690c39 0 70-32 70-70 0-39-31-70-70-70h-4620zM1584 6697c126 0 229 103 229 230s-103 230-229 230c-127 0-230-103-230-230s103-230 230-230zm0 600c204 0 370-166 370-370s-166-370-370-370-370 166-370 370 166 370 370 370z"
          className="fill stroke1"
          style={{
            strokeWidth: 212.127,
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
